import { render, staticRenderFns } from "./VAddress.vue?vue&type=template&id=5da1d2da&scoped=true&"
import script from "./VAddress.vue?vue&type=script&lang=ts&"
export * from "./VAddress.vue?vue&type=script&lang=ts&"
import style0 from "./VAddress.vue?vue&type=style&index=0&id=5da1d2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da1d2da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ec2-user/buildAgent/work/1ca6ccddf1d626f9/resources/vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCombobox,VFlex,VLayout,VTextField})
